<template>
    <div class="duels-filter-sort">
        <div class="sort-title">SORT BY</div>
        <div class="sort-dropdown" v-bind:class="{ 'dropdown-open': duelsDropdown === true }">
            <button v-on:click="duelsToggleDropdown" class="button-toggle">
                {{duelsFilterSort}}
                <IconDropdown />
            </button>
            <div class="dropdown-menu">
                <div class="menu-inner">
                    <button v-on:click="duelsSetValue('HIGHEST PRICE')">HIGHEST PRICE</button>
                    <button v-on:click="duelsSetValue('LOWEST PRICE')">LOWEST PRICE</button>
                    <button v-on:click="duelsSetValue('PARTICIPANTS')">PARTICIPANTS</button>
                    <button v-on:click="duelsSetValue('RECENT')">RECENT</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import IconDropdown from '@/components/icons/IconDropdown';

    export default {
        name: 'DuelsFilterSort',
        components: {
            IconDropdown
        },
        data() {
            return {
                duelsDropdown: false
            }
        },
        methods: {
            ...mapActions([
                'duelsSetFilterSort'
            ]),
           duelsToggleDropdown() {
               this.duelsDropdown = !this.duelsDropdown;
           },
           duelsSetValue(value) {
               this.duelsSetFilterSort(value);
               this.duelsDropdown = false;
           }
        },
        computed: {
            ...mapGetters([
                'duelsFilterSort'
            ])
        },
        created() {
            let self = this;
            document.addEventListener('click', function(event) {
                if(!self.$el.contains(event.target) && self.duelsDropdown == true) {
                    self.duelsToggleDropdown();
                }
            });
        }
    }
</script>

<style scoped>
    .duels-filter-sort {
        position: relative;
        display: flex;
        align-items: center;
        z-index: 5;
    }

    .duels-filter-sort .sort-title {
        margin-right: 8px;
        font-family: 'Satoshi', sans-serif;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.5px;
        color: rgba(184, 115, 51, 0.6);
    }

    .duels-filter-sort .sort-dropdown {
        position: relative;
    }

    .duels-filter-sort .sort-dropdown button.button-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 8px 14px;
        border-radius: 10px;
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.6) 0%, rgba(13, 13, 13, 0.8) 100%);
        border: 1px solid rgba(184, 115, 51, 0.3);
        font-family: 'Satoshi', sans-serif;
        font-size: 12px;
        font-weight: 800;
        letter-spacing: 0.5px;
        color: #ffffff;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    }

    .duels-filter-sort .sort-dropdown button.button-toggle:hover {
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.8) 0%, rgba(13, 13, 13, 0.9) 100%);
        border-color: rgba(184, 115, 51, 0.5);
        box-shadow: 0 4px 12px rgba(184, 115, 51, 0.15);
    }

    .duels-filter-sort .sort-dropdown button.button-toggle svg {
        width: 10px;
        fill: rgba(184, 115, 51, 0.8);
        transition: all 0.3s ease;
    }

    .duels-filter-sort .sort-dropdown.dropdown-open button.button-toggle svg {
         transform: rotate(180deg);
    }

    .duels-filter-sort .dropdown-menu {
        width: 175px;
        height: 0;
        position: absolute;
        top: 23px;
        right: -5px;
        padding: 0 10px;
        transition: height 0.2s ease;
        overflow: hidden;
        z-index: 1;
    }

    .duels-filter-sort .sort-dropdown.dropdown-open .dropdown-menu {
       height: 161px;
       padding: 0 10px 10px 10px;
    }

    .duels-filter-sort .menu-inner {
        width: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 10px;
        border-radius: 12px;
        background: linear-gradient(135deg, rgba(26, 26, 26, 0.95) 0%, rgba(13, 13, 13, 0.98) 100%);
        border: 1px solid rgba(184, 115, 51, 0.3);
        box-shadow: 
            0 8px 32px rgba(0, 0, 0, 0.5),
            inset 0 1px 0 rgba(255, 255, 255, 0.05);
        backdrop-filter: blur(10px);
    }

    .duels-filter-sort .menu-inner::before {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: -8px;
        right: 10px;
        border-left: 8px solid transparent;
        border-right: 8px solid transparent;
        border-bottom: 8px solid rgba(184, 115, 51, 0.3);
    }

    .duels-filter-sort .menu-inner::after {
        content: '';
        width: 0;
        height: 0;
        position: absolute;
        top: -7px;
        right: 11px;
        border-left: 7px solid transparent;
        border-right: 7px solid transparent;
        border-bottom: 7px solid rgba(13, 13, 13, 0.98);
    }

    .duels-filter-sort .menu-inner button {
        width: 100%;
        height: 40px;
        display: flex;
        align-items: center;
        padding: 0 18px;
        font-family: 'Satoshi', sans-serif;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 0.5px;
        color: rgba(184, 115, 51, 0.7);
        border-bottom: 1px solid rgba(184, 115, 51, 0.15);
        transition: all 0.3s ease;
    }

    .duels-filter-sort .menu-inner button:first-of-type {
        border-radius: 12px 12px 0 0;
    }

    .duels-filter-sort .menu-inner button:last-of-type {
        border-radius: 0 0 12px 12px;
        border-bottom: none;
    }

    .duels-filter-sort .menu-inner button:hover {
        color: #ffffff;
        background: rgba(184, 115, 51, 0.1);
        text-shadow: 0 0 10px rgba(184, 115, 51, 0.3);
    }

    @media only screen and (max-width: 768px) {
        .duels-filter-sort {
            display: none;
        }
    }
</style>
